import {
  ANALYTICS_DASHBOARD_CONTENT_ERROR,
  GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
  GET_MORE_ANALYTICS_DASHBOARD_CONTENT,
  GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
  SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
  SET_MORE_ANALYTICS_DASHBOARD_CONTENT,
  SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
  INITIAL_ANALYTICS_DATA_LOADING,
  INITIAL_ANALYTICS_DATA_ERROR,
  INITIAL_ANALYTICS_DATA_RESPONSE
} from '../../Constants/action-types';
// import { filterNotRepeated } from './feed-reducer';

const initialState = {
  tmxMessagesContact: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  customAssociatedConversation: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  liveUsers: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  liveMessages: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  signals: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  success: false,
  error: false,

  loadingInitialTmxMessagesContact: false,
  loadingInitialLiveUsers: false,
  loadingInitialLiveMessages: false,
  loadingInitialSignals: false,
  loadingInitialCustomAssociatedConversation: false,

  loadingMoreTmxMessagesContact: false,
  loadingMoreLiveUsers: false,
  loadingMoreLiveMessages: false,
  loadingMoreSignals: false,
  loadingMoreCustomAssociatedConversation: false,

  loadingPeriodicTmxMessagesContact: false,
  loadingPeriodicLiveUsers: false,
  loadingPeriodicLiveMessages: false,
  loadingPeriodicSignals: false,
  loadingPeriodicCustomAssociatedConversation: false,

  customTrackers: {
    loaded: false,
    results: {}
  },
  createTrackerAlertError: false,
  createTrackerAlertSuccess: false,
  createTrackerAlertValue: '',
  createTrackerError: false,
  createTrackerSuccess: false,
  creatingTracker: false,
  creatingTrackerAlert: false,

  searchedTracker: {
    hasFetchedAll: false,
    loaded: false,
    results: []
  },
  searchCustomTrackerType: '',
  searchCustomTrackerValue: '',
  searchingCustomTracker: false,
  searchingMoreCustomTracker: false,
  customAssociatedRepliesRequestId: null,
  PeriodicCallRunning: false,

  newsroomRequestResolvedLoading: false,
  newsroomRequestResolvedSuccess: false,
  newsroomRequestResolvedError: false,

  customAssociatedConversationRequestId: null,

  responseData: {},
  loading: false
};

export const filterNotRepeated = (arr, item) => {
  const exists = !!arr.find((x) => {
    if (x.isExpertReply) {
      return x.expertReplyId === item.expertReplyId; // may be an error point keep an eye out
    } else {
      return x.id === item.id;
    }
  });
  if (!exists) {
    arr.push(item);
  }

  if (exists && item.delete) {
    arr = arr.filter((x) => x.id !== item.id);
  }

  if (exists && item.edit) {
    arr = arr.filter((x) => x.id !== item.id);
    arr.push(item);
  }

  return arr.sort(function (a, b) {
    return a.time - b.time;
  });
};

export const searchAndReplace = (arr, action) => {
  // const alteredArray = (arr.find((content) => content.id === action.id).rating = action.rating);

  return arr.forEach((content, index) => {
    if (content.id === action.id) {
      arr[index].rating = action.rating;
    }
  });
};

export default function analyticsDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT:
      return {
        ...state,

        loadingInitialTmxMessagesContact:
          action.category === 'TMX_MESSAGES_CONTACT' || state.loadingInitialTmxMessagesContact,
        loadingInitialLiveUsers: action.category === 'LIVE_USERS' || state.loadingInitialLiveUsers,
        loadingInitialLiveMessages:
          action.category === 'LIVE_MESSAGES' || state.loadingInitialLiveMessages,
        loadingInitialSignals: action.category === 'LIVE_SIGNALS' || state.loadingInitialSignals,
        loadingInitialCustomAssociatedConversation:
          action.category === 'LIVE_REPLIES' || state.loadingInitialCustomAssociatedConversation,
        customAssociatedConversationRequestId:
          'requestId' in action ? action.requestId : state.customAssociatedConversationRequestId,

        error: false
      };
    case GET_MORE_ANALYTICS_DASHBOARD_CONTENT:
      return {
        ...state,
        loadingMoreTmxMessagesContact: action.category === 'TMX_MESSAGES_CONTACT',
        loadingMoreLiveUsers: action.category === 'LIVE_USERS',
        loadingMoreLiveMessages: action.category === 'LIVE_MESSAGES',
        loadingMoreSignals: action.category === 'LIVE_SIGNALS',
        loadingMoreCustomAssociatedConversation: action.category === 'LIVE_REPLIES',
        error: false
      };
    case GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT:
      return {
        ...state,

        loadingPeriodicTmxMessagesContact:
          action.category === 'TMX_MESSAGES_CONTACT' || action.category === 'ALL_CHAT',
        loadingPeriodicLiveUsers:
          action.category === 'LIVE_USERS' || action.category === 'ALL_CHAT',
        loadingPeriodicLiveMessages:
          action.category === 'LIVE_MESSAGES' || action.category === 'ALL_CHAT',
        loadingPeriodicSignals:
          action.category === 'LIVE_SIGNALS' || action.category === 'ALL_CHAT',
        loadingPeriodicCustomAssociatedConversation:
          action.category === 'LIVE_REPLIES' || action.category === 'ALL_CHAT',

        PeriodicCallRunning: true
      };
    case SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT:
      if (action.category?.toUpperCase() === 'LIVE_USERS') {
        return {
          ...state,
          loadingInitialLiveUsers: false,
          liveUsers: {
            loaded: true,
            results: action.media.liveUsers.results,
            hasFetchedAll: action.media.liveUsers.results.length < 20
          }
        };
      } else if (action.category?.toUpperCase() === 'LIVE_MESSAGES') {
        return {
          ...state,
          loadingInitialLiveMessages: false,
          liveMessages: {
            loaded: true,
            results: action.media.liveMessages.results,
            hasFetchedAll: action.media.liveMessages.results.length < 20
          }
        };
      } else if (action.category?.toUpperCase() === 'LIVE_SIGNALS') {
        return {
          ...state,
          loadingInitialSignals: false,
          signals: {
            loaded: true,
            results: action.media.signals.results,
            hasFetchedAll: action.media.signals.results.length < 20
          }
        };
      } else if (action.category?.toUpperCase() === 'LIVE_REPLIES') {
        return {
          ...state,
          loadingInitialCustomAssociatedConversation: false,
          customAssociatedConversation: {
            loaded: true,
            results: action.media.customAssociatedConversation.results,
            hasFetchedAll: action.media.customAssociatedConversation.results.length < 20
          }
        };
      } else
        return {
          ...state,
          loadingInitialTmxMessagesContact: false,
          tmxMessagesContact: {
            loaded: true,
            results: action.media.tmxMessagesContact.results,
            hasFetchedAll: action.media.tmxMessagesContact.results.length < 20
          }
        };
    case SET_MORE_ANALYTICS_DASHBOARD_CONTENT:
      return {
        ...state,

        tmxMessagesContact: {
          loaded: true,
          results: [
            ...state.tmxMessagesContact.results,
            ...action.media.tmxMessagesContact.results
          ].reduce(filterNotRepeated, []),
          hasFetchedAll:
            action.category === 'TMX_MESSAGES_CONTACT' &&
            action.media.tmxMessagesContact.results.length <= 0
              ? true
              : state.tmxMessagesContact.hasFetchedAll
        },
        customAssociatedConversation: {
          loaded: true,
          results: [
            ...state.customAssociatedConversation.results,
            ...action.media.customAssociatedConversation.results
          ].reduce(filterNotRepeated, []),
          hasFetchedAll:
            action.category === 'LIVE_REPLIES' &&
            action.media.customAssociatedConversation.results.length <= 0
              ? true
              : state.customAssociatedConversation.hasFetchedAll
        },
        liveUsers: {
          loaded: true,
          results: [...state.liveUsers.results, ...action.media.liveUsers.results].reduce(
            filterNotRepeated,
            []
          ),
          hasFetchedAll:
            action.category === 'LIVE_USERS' && action.media.liveUsers.results.length <= 0
              ? true
              : state.liveUsers.hasFetchedAll
        },
        liveMessages: {
          loaded: true,
          results: [...state.liveMessages.results, ...action.media.liveMessages.results].reduce(
            filterNotRepeated,
            []
          ),
          hasFetchedAll:
            action.category === 'LIVE_MESSAGES' && action.media.liveMessages.results.length <= 0
              ? true
              : state.liveMessages.hasFetchedAll
        },
        signals: {
          loaded: true,
          results: [...state.signals.results, ...action.media.signals.results].reduce(
            filterNotRepeated,
            []
          ),
          hasFetchedAll:
            action.category === 'LIVE_SIGNALS' && action.media.signals.results.length <= 0
              ? true
              : state.signals.hasFetchedAll
        },

        loadingMoreTmxMessagesContact: false,
        loadingMoreLiveUsers: false,
        loadingMoreLiveMessages: false,
        loadingMoreSignals: false,
        loadingMoreCustomAssociatedConversation: false
      };
    case SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT:
      return {
        ...state,

        tmxMessagesContact: {
          ...state.tmxMessagesContact,
          loaded: true,
          results: [
            ...action.media.tmxMessagesContact.results,
            ...state.tmxMessagesContact.results
          ].reduce(filterNotRepeated, [])
        },
        customAssociatedConversation: {
          ...state.customAssociatedConversation,
          loaded: true,
          results: [
            ...action.media.customAssociatedConversation.results,
            ...state.customAssociatedConversation.results
          ].reduce(filterNotRepeated, [])
        },
        liveUsers: {
          ...state.liveUsers,
          loaded: true,
          results: [...action.media.liveUsers.results, ...state.liveUsers.results].reduce(
            filterNotRepeated,
            []
          )
        },
        liveMessages: {
          ...state.liveMessages,
          loaded: true,
          results: [...action.media.liveMessages.results, ...state.liveMessages.results].reduce(
            filterNotRepeated,
            []
          )
        },
        signals: {
          ...state.signals,
          loaded: true,
          results: [...action.media.signals.results, ...state.signals.results].reduce(
            filterNotRepeated,
            []
          )
        },

        loadingPeriodicTmxMessagesContact: false,
        loadingPeriodicLiveUsers: false,
        loadingPeriodicLiveMessages: false,
        loadingPeriodicSignals: false,
        loadingPeriodicCustomAssociatedConversation: false
      };
    case ANALYTICS_DASHBOARD_CONTENT_ERROR:
      return {
        ...state,
        error: true,

        loadingPeriodicTmxMessagesContact: false,
        loadingPeriodicLiveUsers: false,
        loadingPeriodicLiveMessages: false,
        loadingPeriodicSignals: false,
        loadingPeriodicCustomAssociatedConversation: false,

        loadingMoreTmxMessagesContact: false,
        loadingMoreLiveUsers: false,
        loadingMoreLiveMessages: false,
        loadingMoreSignals: false,
        loadingMoreCustomAssociatedConversation: false,

        loadingInitialTmxMessagesContact: false,
        loadingInitialLiveUsers: false,
        loadingInitialLiveMessages: false,
        loadingInitialSignals: false,
        loadingInitialCustomAssociatedConversation: false
      };

    case INITIAL_ANALYTICS_DATA_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false
      };
    case INITIAL_ANALYTICS_DATA_ERROR:
      return { ...state, error: true, loading: false, success: false };
    case INITIAL_ANALYTICS_DATA_RESPONSE:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        responseData: action.value,
        combinedMapData: action.combinedMapData
      };

    default:
      return state;
  }
}
